exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-image {\n  width: 95% !important;\n}\n.responsive-desktop {\n  display: block;\n}\n.responsive-mobile {\n  display: none;\n}\n@media (max-width: 1200px) {\n.logo-image {\n    width: 60% !important;\n}\n}\n@media (max-width: 600px) {\n.logo-image {\n    width: 70% !important;\n}\n}\n@media (max-width: 450px) {\n.logo-image {\n    width: 80% !important;\n}\n}\n.mainSection {\n  padding-right: 0px !important;\n  padding-left: 0px !important;\n}", ""]);

// exports
